<lib-legal-information [labels]="'lib.legalInformation' | translate" [bigTitle]="bigTitle | translate" [legalInfo]="legalInfo" [bank]="bank" [website]="website"></lib-legal-information>
